'use strict';

var is_valid_moment_object = require('../helpers/is-valid-moment-object');

module.exports = function (property) {

      if (is_valid_moment_object(property)) return property.format(this.opts.dateFormat);

      return property;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/filters/date.js
// module id = 1291
// module chunks = 0